/**
 * Search for 'Other symbols' on this page
 * https://www.jetbrains.com/lp/mono/#key-features
 *
 * This only works for the JetBrains Mono font
 */

export const GLYPHS = {
  vertical: "↕",
  right: "→",
  left: "←",
  down: "↓",
  external: "↗",
  check: "✓",
}
